import { Injectable } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material';
import { SuccessDialogComponent } from '../success-dialog/success-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class SuccessDialogService {

  constructor(public dialog: MatDialog) {
  }

  // ===== Success Dialog =====
  successDialog(learningStatusCode): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;

    if (learningStatusCode == 1) {
      dialogConfig.data = {
        title: 'Basics of Patents',
        routerLink: '/main/learning/basicOfPatentTest'
      };
    }
    if (learningStatusCode == 2) {
      dialogConfig.data = {
        title: 'Patent Drawing',
        routerLink: '/main/learning/learnPatentSearch'
      };
    }
    if (learningStatusCode == 3) {
      dialogConfig.data = {
        title: 'Patent Search',
        routerLink: '/main/learning/patentSearchTest'
      };
    }
    if (learningStatusCode == 4) {
      dialogConfig.data = {
        title: 'Patent Draft',
        routerLink: '/main/learning/patentDraftTest'
      };
    }
    if (learningStatusCode == 5) {
      dialogConfig.data = {
        title: 'Learning module. We welcome you to generate your own patent application.',
        routerLink: '/main/nda'
      };
    }

    const dialogRef = this.dialog.open(SuccessDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  successDialogDoing(doingStatusCode, projectId): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;

    if (doingStatusCode == 6) {
      dialogConfig.data = {
        title: 'Basic Invention Details',
        routerLink: '/main/patentDrawing/' + projectId
      };
    }
    if (doingStatusCode == 7) {
      dialogConfig.data = {
        title: 'Patent Drawing',
        routerLink: '/main/patentSearch/' + projectId
      };
    }
    if (doingStatusCode == 8) {
      dialogConfig.data = {
        title: 'Patent Search',
        routerLink: '/main/patentDraft/' + projectId
      };
    }

    const dialogRef = this.dialog.open(SuccessDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
      // console.log(result);

    });
  }
}
